import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { FormattedMessage } from "react-intl";
import { GeneralUtils } from "../utils";
import { LocalizationMessages } from "../localization/messages";
import { UserContextActionCreators } from "../redux/action-creators";
import { UserContextSelectors } from "../redux/selectors";

const SESSION_TIME_UPDATE_INTERVAL = 10 * 1000; //seconds

const SessionTime = () => {
  const dispatch = useDispatch();
  const sessionTime = useSelector(UserContextSelectors.sessionTime);
  const [formattedSessionTime, setFormattedSessionTime] = useState("");

  useEffect(() => {
    const startSessionTimeTask = () =>
      dispatch(UserContextActionCreators.startSessionTimeTask());

    const stopSessionTimeTask = () =>
      dispatch(UserContextActionCreators.stopSessionTimeTask());

    const timeout = setTimeout(
      startSessionTimeTask,
      SESSION_TIME_UPDATE_INTERVAL
    );

    return () => {
      stopSessionTimeTask();
      clearTimeout(timeout);
    };
  }, [dispatch]);

  useEffect(() => {
    setFormattedSessionTime(GeneralUtils.getFormattedSessionTime(sessionTime));
  }, [sessionTime]);

  return (
    <p>
      <FormattedMessage {...LocalizationMessages.sessionTime} />{" "}
      {formattedSessionTime}
    </p>
  );
};

export default React.memo(SessionTime);
